import React from "react";
import { Button,Image } from "antd";
import { Header } from "../../../../components/Landing/Header/haeder.view";
import { BannerPanelRegistroUsuarios } from "../../components/BannerPanelRegistroUsuarios";
import { Footer } from "../../../../components/Landing/Footer";
import { useNavigate } from "react-router-dom";
import ImageAyudaRegistro from "../../../../assets/landing/ImageAyudaRegistro.png";

export const RegistroExitoso = () => {
  const navigate = useNavigate();
  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <BannerPanelRegistroUsuarios />
      <div className="container-fluid2">
        <div className="row">
          <div className="text-center col-12 font-size-18px font-family-Montserrat-Bold">
            ¡GENIAL! Te has registrado con éxito.
          </div>
          <div className="text-center col-12 font-size-18px font-family-Montserrat-Regular">
          En caso que ya estés registrado en <strong>Medellin.gov.co</strong> usa los mismos datos de acceso. <button type="button" style={{color: "#1890ff"}} onClick={()=>{navigate("/login")}}>Ingresando Aquí</button>
          </div>
          <div className="text-center col-12 font-size-18px font-family-Montserrat-Regular">
          Si es tu primera vez, una contraseña provisional será enviada a tu dirección de correo electrónico.
          </div>
          <div className="col-12 d-flex justify-content-center">
          <Image className="text-center" width={400} src={ImageAyudaRegistro} preview={true} />
          </div>
          <div className="text-center col-12 font-size-18px font-family-Montserrat-Regular">
          Si ya tienes tu contraseña provisional, presiona continuar y cámbiala por una de tu elección.
          </div>
          
          <div className="col-12 d-flex justify-content-flex-end">
            <Button className="button-azul-radius" onClick={() => navigate("/login")}>
              Continuar
            </Button>
          </div>
        </div>
      </div>
      <Footer className="mt-auto" />
    </div>
  );
};
